import api from '@/lib/axios';
import type { Guest, CreateGuestDTO, UpdateGuestDTO, ApiResponse, LaravelPaginator } from '@/types';

/**
 * Serviço de hóspedes.
 * Rotas: /v1/hospedes/*
 */
export const guestsService = {
  /**
   * Listar todos os hóspedes
   * GET /v1/hospedes
   */
  async list(params?: { page?: number; per_page?: number; search?: string }): Promise<LaravelPaginator<Guest>> {
    const { data } = await api.get<ApiResponse<{ guests: LaravelPaginator<Guest> }>>('/v1/hospedes', { params });
    return data.data.guests;
  },

  /**
   * Obter hóspede por ID
   * GET /v1/hospedes/:id
   */
  async get(id: number): Promise<Guest> {
    const { data } = await api.get<ApiResponse<{ guest: Guest }>>(`/v1/hospedes/${id}`);
    return data.data.guest;
  },

  /**
   * Criar novo hóspede
   * POST /v1/hospedes
   */
  async create(payload: CreateGuestDTO): Promise<Guest> {
    const { data } = await api.post<ApiResponse<{ guest: Guest }>>('/v1/hospedes', payload);
    return data.data.guest;
  },

  /**
   * Atualizar hóspede (full replace)
   * PUT /v1/hospedes/:id
   */
  async update(id: number, payload: UpdateGuestDTO): Promise<Guest> {
    const { data } = await api.put<ApiResponse<Guest>>(`/v1/hospedes/${id}`, payload);
    return data.data;
  },

  /**
   * Atualiza parcialmente o hóspede, preservando preferências existentes
   * PATCH /v1/hospedes/:id
   */
  async patch(id: number, payload: Partial<UpdateGuestDTO>): Promise<Guest> {
    const { data } = await api.patch<ApiResponse<Guest>>(`/v1/hospedes/${id}`, payload);
    return data.data;
  },

  /**
   * Deletar hóspede
   * DELETE /v1/hospedes/:id
   */
  async delete(id: number): Promise<void> {
    await api.delete(`/v1/hospedes/${id}`);
  },
};
